import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IAddDocumentTypePayload, IEditDocumentTypePayload } from './document-type.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DocumentTypeService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private listDocumentTypeUrl =
        this.basePath +
        environment.interop.deps.nomenclatoare.cerereDocumentType.list;
    private listDTDocumentTypeUrl =
        this.basePath +
        environment.interop.deps.nomenclatoare.cerereDocumentType.listDT;
    private findDocumentTypeUrl =
        this.basePath +
        environment.interop.deps.nomenclatoare.cerereDocumentType.find;

    private storeDocumentTypeURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.cerereDocumentType.store;
    private putDocumentTypeURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.cerereDocumentType.update;

    private deleteDocumentTypeURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.cerereDocumentType.delete;

    private clearCacheUrl =
        this.basePath +
        environment.interop.deps.nomenclatoare.cerereDocumentType.clearCache;

    constructor(private http: HttpClient) { }

    listDocumentType() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.listDocumentTypeUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get document types:', error);
                    return throwError(error);
                })
            );
    }

    listDTDocumentType() {
        return this.http.post(this.listDTDocumentTypeUrl, this.httpOptions);
    }

    findDocumentType() {
        return this.http.get(this.findDocumentTypeUrl, this.httpOptions);
    }

    addDocumentType(type: IAddDocumentTypePayload) {
        return this.http.post(this.storeDocumentTypeURL, type, this.httpOptions);
    }

    updateDocumentType(type: IEditDocumentTypePayload) {
        return this.http.put(this.putDocumentTypeURL, type, this.httpOptions);
    }

    deleteDocumentType(typeId: number) {
        return this.http.delete(this.deleteDocumentTypeURL + typeId);
    }

    clearCache() {
        return this.http.get(this.clearCacheUrl, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
